import React from 'react';
import { DeviceIconProps, getSizeInPixels } from '../types';

/**
 * TH Sensor Icon Style 02 - Water Drop (Material Symbol)
 * For humidity-focused or humidity-only sensors
 * 
 * @see https://fonts.google.com/icons?selected=Material+Symbols+Outlined:water_drop
 */
export const Style02_WaterDrop: React.FC<DeviceIconProps> = ({ 
  size = 'small',
  className = '',
}) => {
  const pixelSize = getSizeInPixels(size);
  const colorClass = 'text-blue-500';

  return (
    <span 
      className={`material-symbols-outlined ${colorClass} ${className}`}
      style={{ 
        fontSize: `${pixelSize}px`,
        fontVariationSettings: `'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 24`
      }}
    >
      water_drop
    </span>
  );
};

export default Style02_WaterDrop;
